import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Footer from '../components/Footer';
import { useSafeBack } from '../hooks/useSafeBack';

const CommunityGuidelines = () => {
  const navigate = useNavigate();
  const { goBack } = useSafeBack('/');

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-8">
          {/* Back Button + Home */}
          <div className="flex items-center gap-2 mb-6">
            <Button
              variant="ghost"
              onClick={goBack}
              className="h-10 px-0 text-sm font-medium text-zinc-500 hover:text-zinc-900 hover:bg-transparent"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/dashboard')}
              className="h-8 w-8"
              data-testid="nav-home-btn"
              aria-label="Home"
            >
              <Home className="w-4 h-4 text-zinc-400" />
            </Button>
          </div>

          {/* Header */}
          <h1 className="text-3xl font-bold text-zinc-900 mb-8">Community Guidelines</h1>

          {/* Content */}
          <div className="prose prose-zinc max-w-none">
            <p className="text-zinc-700 text-lg leading-relaxed mb-8">
              Open Runs USA is built around respect and sportsmanship.
            </p>

            {/* Players Should */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Players should:</h2>
            <ul className="list-disc pl-6 text-zinc-700 space-y-2 mb-6">
              <li>Respect other players</li>
              <li>Show up to games they join</li>
              <li>Communicate if they cannot attend</li>
              <li>Play safely and competitively</li>
            </ul>

            {/* Players Should Not */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Players should not:</h2>
            <ul className="list-disc pl-6 text-zinc-700 space-y-2 mb-6">
              <li>Harass others</li>
              <li>Create fake games</li>
              <li>Abuse messaging features</li>
              <li>Disrupt games intentionally</li>
            </ul>

            {/* Violations */}
            <p className="text-zinc-700 text-lg leading-relaxed mt-8 font-medium">
              Violations may result in account suspension.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CommunityGuidelines;
